import React from "react"
import { Link as ChakraLink } from "@chakra-ui/react"
import { Link as ReactRouterLink } from "react-router-dom"

const Link = React.forwardRef(function Link({ children, ...props }, ref) {
  return (
    <ChakraLink
      ref={ref}
      as={ReactRouterLink}
      textDecoration="none"
      _hover={{ textDecoration: "none" }}
      {...props}
    >
      {children}
    </ChakraLink>
  )
})

export default Link
